import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-learner-video-observation',
  templateUrl: './learner-video-observation.component.html',
  styleUrls: ['./learner-video-observation.component.scss']
})
export class LearnerVideoObservationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
